<template>
  <div class="footer-layout text-white">
      <div class="main default-win-width">
          <div class="first-block">
              <div class="logo">
                  <img :src="require('@/assets/img/footer-logo-first.svg')" alt="logo">
                  <img :src="require('@/assets/img/second-logo.svg')" alt="logo">
              </div>
              <span>{{t('mainTitle')}}</span>
          </div>
          <div class="second-block">
              <span class="title">{{t('contacts')}}</span>
              <span>+996 (312) 615187</span>
              <span>contact@mammulk.kg</span>
              <span>{{t('gaugiAddress')}}</span>
              <span>{{t('gr')}}</span>
              <span>{{t('gr2')}}</span>
          </div>
          <div class="second-block">
              <span class="title">{{t('parts')}}</span>
              <a href="/about/position">{{t('about')}}</a>
              <a href="/regulatory_framework/legislation">{{t('regulatoryFramework')}}</a>
              <a href="/activity/corruption">{{t('activity')}}</a>
              <a href="/media/news">{{t('smi')}}</a>
              <a href="/contacts/phone-directory">{{t('contacts')}}</a>
              <a href="http://www.net.kg/stat.php?id=7308&amp;fromsite=7308" target="_blank">{{t('metric')}}</a>
          </div>
          <div class="second-block">
              <span class="title">{{t('govWeb')}}</span>
              <a href="https://president.kg/" target="_blank">{{t('govWeb1')}}</a>
              <a href="https://www.kenesh.kg/" target="_blank">{{t('govWeb2')}}</a>
              <a href="https://www.gov.kg/ky" target="_blank">{{t('govWeb3')}}</a>
              <a href="https://cbd.minjust.gov.kg/430234/edition/1042427/ru" target="_blank">{{t('govWeb4')}}</a>
              <a href="http://zakupki.gov.kg/popp/" target="_blank">{{t('govWeb5')}}</a>
              <a href="https://data.gov.kg/" target="_blank">{{t('govWeb6')}}</a>
              <a href="http://www.kattar.kg/ru/" target="_blank">{{t('govWeb7')}}</a>
              <a href="https://www.stat.gov.kg/ru/" target="_blank">{{t('govWeb8')}}</a>
          </div>
      </div>
      <div class="divider default-win-width"/>
      <div class="contacts default-win-width">
          <span>{{t('devtext')}}</span>
          <div class="contact">
              <a v-for="(image, index) in contactsList" :key="index" :href="image.href" target="_blank"><img :src="image.src" alt="contact"></a>
          </div>
      </div>
  </div>
</template>

<script setup>
import {ref} from "vue";
import {useI18n} from "vue-i18n";

const {t} = useI18n();
const contactsList = ref([
    {src: require('@/assets/icon/facebook.svg'), href: 'https://www.facebook.com/fugi.gov.kg/'},
    // {src: require('@/assets/icon/instagram.svg'), href: ''},
    // {src: require('@/assets/icon/tiktok.svg'), href: ''},
    {src: require('@/assets/icon/youtube.svg'), href: 'https://www.youtube.com/channel/UCYJ_srO0f1-oeAdJjSumSEA?view_as=subscriber'},
    {src: require('@/assets/icon/whatsapp.svg'), href: 'https://api.whatsapp.com/send/?phone=996550615187&text&type=phone_number&app_absent=0'},
    // {src: require('@/assets/icon/telegram.svg'), href: ''},
]);
</script>
